import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import withHandlers from 'recompose/withHandlers';
import { connect } from 'react-redux';
import { withModel } from '../../../data-providers/model';
import withCountry from '../../../hocs/withCountry';
import withCountries from '../../../hocs/withCountries';
import { updateActivePopup, getActivePopup } from '../duck';
import CountryToggle from './CountryToggle';
import { setCloseOverlay, setOpenOverlay } from '../../../../store/actions/app';
import withMediaQueries from '../../../hocs/withMediaQueries';

const enhance = compose(
  withModel,
  withCountry,
  withCountries,
  withMediaQueries,
  connect(
    state => ({
      isOpen: getActivePopup(state) === 'country',
    }),
    dispatch => ({
      openOverlay: scrollPos => dispatch(setOpenOverlay(scrollPos)),
      closeOverlay: () => dispatch(setCloseOverlay()),
      setActivePopup: () => dispatch(updateActivePopup('country')),
    }),
  ),
  withHandlers({
    handleCountryClick: props => e => {
      if (!props.isOpen && window) {
        props.setActivePopup();
        if (props.media.desktopDown) {
          props.openOverlay(window.scrollY);
        }
      } else {
        props.setActivePopup();
        props.closeOverlay();
      }
    }
  }),
  mapProps(props => ({
    ...props,
    changeCountryLink:
      props.changeCountryLink ||
      props.model.prismicNavigationModel.changeCountryLink,
    countryHeading:
      props.countryHeading ||
      props.model.prismicNavigationModel.changeCountryHeading,
  })),
);

export default enhance(CountryToggle);
